import { render, staticRenderFns } from "./global-state-aggregator-oro-watcher.vue?vue&type=template&id=0e1fbfb0&scoped=true&"
import script from "./global-state-aggregator-oro-watcher.vue?vue&type=script&lang=js&"
export * from "./global-state-aggregator-oro-watcher.vue?vue&type=script&lang=js&"
import style0 from "./global-state-aggregator-oro-watcher.vue?vue&type=style&index=0&id=0e1fbfb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1fbfb0",
  null
  
)

export default component.exports